<template>
    <b-modal title="Edit firmware package" v-model="editFirmwarePackageModalActive" no-close-on-backdrop>
        <template #default>
            <b-form-group>
                <label>Terminal model</label>
                <v-select
                    v-model="editObject.terminal_model_id"
                    :reduce="model => model.id"
                    label="name"
                    :options="terminalModels"
                />
            </b-form-group>

            <b-form-group>
                <label>Version</label>
                <b-form-input v-model="editObject.version"/>
            </b-form-group>

            <FirmwarePackageFileSelector v-model="editObject.firmware_package_file_id"/>

            <b-form-group>
                <label>AB Upgrade Meta</label>
                <b-form-textarea v-model="editObject.ab_meta_info"/>
            </b-form-group>

            <b-form-group>
                <label>Upgrade Info</label>
                <b-form-textarea v-model="editObject.info"/>
            </b-form-group>

        </template>

        <template #modal-footer>

            <b-button variant="danger" @click="editFirmwarePackageModalActive = false">
                <feather-icon
                    icon="XIcon"
                    class="mr-50"
                />
                <span class="align-middle">Close</span>
            </b-button>

            <b-button variant="warning" @click="saveFirmwarePackage" :disabled="editObject.firmware_package_file_id.length === 0">
                <feather-icon
                    icon="EditIcon"
                    class="mr-50"
                />
                <span class="align-middle">Save</span>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import {BButton, BFormGroup, BFormInput, BModal, BFormTextarea} from 'bootstrap-vue'
    import vSelect from 'vue-select'
    import FirmwarePackageFileSelector from '@/views/components/FirmwarePackageFileSelector'

    export default {
        props: {
            terminalModels: {
                type: Array,
                required: true
            }
        },
        components: {
            FirmwarePackageFileSelector,
            BButton,
            BFormGroup,
            BFormInput,
            BModal,
            BFormTextarea,
            vSelect
        },
        data() {
            return {
                editFirmwarePackageModalActive: false,
                editObject: {
                    terminal_model_id: '',
                    info: '',
                    version: '',
                    firmware_package_file_id: '',
                    ab_meta_info: ''
                }
            }
        },
        methods: {
            open(object) {
                this.editObject = JSON.parse(JSON.stringify(object))
                this.editFirmwarePackageModalActive = true
            },
            saveFirmwarePackage() {
                const thisIns = this
                const savePromise = this.$http.put(`/api/management/v1/firmware_package/${  this.editObject.id}`, this.editObject)
                savePromise.then(function() {
                    thisIns.$printSuccess('Firmware package saved')
                    thisIns.editFirmwarePackageModalActive = false
                    thisIns.editObject = {
                        terminal_model_id: '',
                        info: '',
                        version: '',
                        firmware_package_file_id: '',
                        ab_meta_info: ''
                    }
                    thisIns.$emit('itemSaved')
                }).catch(function(error) {
                    thisIns.$printError((error.response) ? error.response.data : error)
                })
            }
        }
    }
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>